import {throttle} from "lodash-es";

ready().then(function() {
    let navList = $('.nav-anchors-list');
    let anchors = $('.section-nav-anchors');
    let headerAnchors = $('header .nav-anchors-container');
    let navItems = $("section[data-nav-title]:not([data-nav-title=''])");

    //Hide menu if less than 3 items
    if(navItems.length < 3) {
        anchors.hide();
    }
    if(headerAnchors.length > 0 && navItems.length < 3) {
        headerAnchors.hide();
    }

    //Build navigation html
    $.each( navItems, function( key, section ){
        let navTitle = $(section).data('nav-title');
        let navId = $(section).attr('id');
        let navAnchor = navId.replace(/^nav-/, ''); // Should intentionally be different to prevent native browser anchoring when accessing a URL directly

        navList.append('<li><a data-scroll="#'  + navId + '" href="#' + navAnchor + '"><span>' + navTitle + '</span></a></li>');
    });

    //Smooth scroll to component
    function scrollToTarget(target)
    {
        let header = $('header.header'),
            mainNav = $('header .nav-container'),
            headerAnchorsOutsideHeader = header.height() >= headerAnchors.offset().top - header.offset().top, // Because styling approach can differentiate per site
            offset = 0,
            headerHeight = header.height() || 0,
            headerAnchorsHeight = 0,
            mainNavHeight = 0,
            adminbarHeight = 0;

        if ($(target).length === 0) {
            return;
        }

        // Support for floating in-page navigation
        if (headerAnchors.hasClass('is-visible')) {
            headerAnchorsHeight = headerAnchors.height();
        } else {
            headerAnchors.addClass('notransition is-visible');
            headerAnchorsHeight = headerAnchors.height(); // Get height for when it isn't floating yet
            headerAnchors.removeClass('notransition is-visible');
        }

        // Support for conditionally hidden main nav (dbb + cargo)
        if (headerAnchorsOutsideHeader === false && mainNav.attr('data-navbar-state') === 'navbar-scroll') {
            mainNav.addClass('notransition').attr('data-navbar-state', 'navbar-default');
            mainNavHeight = -mainNav.height(); // Subtract height for when it isn't showing yet
            mainNav.attr('data-navbar-state', 'navbar-scroll');
            setTimeout(function () {
                mainNav.removeClass('notransition'); // setTimout prevents flickering
            }, 1);
        }

        // Support for wpadminbar
        if ($('body').hasClass('admin-bar')) {
            adminbarHeight = parseInt($('html').css('marginTop'));
        }

        // Calculate dynamic offset
        offset = headerHeight + headerAnchorsHeight + mainNavHeight + adminbarHeight;

        $('html, body').stop().animate({
            'scrollTop': $(target).offset().top - offset
        }, 1000, function () {
            // restore AOS animations?
        });

    }

    $('a[data-scroll]').on('click', function (e) {
        e.preventDefault();

        let href = $(this).attr('href');
        let target = $(this).data('scroll');

        if (target === true) {
            target = href;
        }

        if (typeof target === 'undefined') {
            target = href;
            href = href.replace('#nav-', '#');
        }

        scrollToTarget(target);
        history.replaceState({}, '', href);
    });

    $('a[data-type="internal"]').on('click',function(e) { // VER-5255
        e.preventDefault();
        let target = $(this).attr('href');

        scrollToTarget(target);
        history.replaceState({}, '', target);
    });


    /**
     * In some websites we have in-page navigation within the main section as well. In that case we need this below function for the following:
     * If the nav-section reaches the header, we have to tell the nav-anchors section in the header to be visible (on the bottom the header)
     */

    function toggleHeaderNavAnchors() {
        let sectionNavAnchors = $('main .section-nav-anchors');
        let headerNavAnchors = $('header .nav-anchors-container');
        let header = $('.header');

        if (sectionNavAnchors.length > 0) {

            $(document).on('scroll',function() {
                const scrollPos = document.documentElement.scrollTop;

                if(scrollPos > sectionNavAnchors.offset().top - 160 && sectionNavAnchors.css('display') !== 'none') {
                    headerNavAnchors.addClass('is-visible');
                    header.attr('data-navanchors-header-state', 'is-visible');
                }
                else {
                    headerNavAnchors.removeClass('is-visible');
                    header.attr('data-navanchors-header-state', 'is-hidden'); // we need this state otherwise the css transitions does not work
                }
            });
        }
    }


    /**
     * Add an active state to in-page-nav when a section is in the viewport (height)
     *
     */
    function addActiveStateWhenInViewport() {
        let navAnchorsList = $('.nav-anchors-list');
        let navAnchorItem = navAnchorsList.find('li a');

        $(document).on('resize scroll', function() {
            const section = $('main section');

            section.each(function(i) {

                if ($(this).isInViewport()) {
                    $(this).addClass('is-in-viewport');

                    var currentSectionId = '#' + $(this).attr('id');

                    if (currentSectionId.indexOf('nav-') > -1) {
                        var currentSectionId = '#' + $(this).attr('id').replace(/^nav-/, '');
                    }

                    if(currentSectionId.length > 0) {
                        navAnchorItem.each(function() {
                            let currentNavAnchorItem = $(this).attr('href').replace(/^nav-/, '');

                            if(currentSectionId === currentNavAnchorItem) {
                                $(this).addClass('is-active');
                                $(this).closest('li').addClass('has-active-item');
                            } else {
                                $(this).removeClass('is-active');
                                $(this).closest('li').removeClass('has-active-item');
                            }
                        });
                    }
                } else {
                    $(this).removeClass('is-in-viewport');
                }
            });
        });
    }

    /**
     * Let the active in page navigation item to be always positioned on the left side of the screen
     */
    function scrollToProperNavItem() {
        let navAnchorsContainer = $('.header .nav-anchors-container');
        if(themeSettings.header.variant == 'variant-kb') {
            navAnchorsContainer = $('.header .nav-anchors');
        }
        let navItems =  $('.header .nav-anchors-container li a');
        let header = $('header.header');

        if(navAnchorsContainer.length > 0 && navAnchorsContainer.css('display') !== 'none') { // in this case it's necessary to use the css property instead if is(visible) with jQuery
            $(document).on('resize scroll load', () => {
                navItems.each(function() {
                    if($(this).hasClass('is-active')) {
                        let xPos = this.offsetParent.offsetLeft;
                        if(themeSettings.header.variant == 'variant-kb') {
                            if(navAnchorsContainer.parent().hasClass('is-wider-then-vp')) {
                                navAnchorsContainer.scrollLeft(xPos - 50); // 50 is need to have it not aligned under the small overlay
                            } 
                        } else if(themeSettings.header.variant != 'variant-kb') {
                            navAnchorsContainer.scrollLeft(xPos - 50);
                        }
                    }
                })
            });

            $(document).on('scroll', throttle(() => {
                if(header.attr('data-header-state') === 'default' ) { // pull the entire nav anchors container to the left on default header state (on top - see VER-3699)
                    navAnchorsContainer.scrollLeft(0);
                }
            }, 200));
        }
    }

    /**
     * We need to calculate the total width of the anchorslist and check that width with the current viewport width
     */

    function checkTotalWidthNavAnchors() {

        let anchorslist = $('main .nav-anchors-list'); // only the anchorslist in the main
        let anchorscontainer = $('main .nav-anchors-container'); // only the anchors container in the main
        let headeranchorscontainer = $('.header .nav-anchors-container');
        let mainwidthanchorslist = 0;

        $(anchorslist).children().each(function () {
            mainwidthanchorslist += $(this).outerWidth(true); // include paddings and such
        });

        if(document.documentElement.clientWidth <= mainwidthanchorslist) {
            anchorscontainer.addClass('is-wider-then-vp') // is wider then viewport
            headeranchorscontainer.addClass('is-wider-then-vp');
        }
    }


    /**
     *  Execute above functions when they meet boolean condition in theme.php
     */
    if (themeSettings.nav_anchors_in_main) {
        toggleHeaderNavAnchors();
    }
    addActiveStateWhenInViewport();
    scrollToProperNavItem();
    checkTotalWidthNavAnchors();
});
